import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Soundboard", -1)
const _hoisted_3 = { class: "operations-list" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Commits:", -1)
const _hoisted_5 = { class: "operations-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logDoc && _ctx.logDoc(...args)))
        }, "log doc")
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.commit && _ctx.commit(...args))),
          class: "flex-none"
        }, "Commit:"),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.message) = $event)),
          placeholder: "message"
        }, null, 512), [
          [_vModelText, _ctx.message]
        ]),
        _createTextVNode(" Author: "),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.author) = $event)),
          class: "flex-none min-w-0",
          style: { 'flex-basis': '4ch' }
        }, null, 512), [
          [_vModelText, _ctx.author]
        ])
      ])
    ]),
    _hoisted_4,
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commits, (commit, i) => {
        return (_openBlock(), _createElementBlock("li", { key: i }, [
          _createElementVNode("input", {
            type: "checkbox",
            value: "false",
            onClick: ($event: any) => (_ctx.toggleCommit(i)),
            class: "flex-none"
          }, null, 8, _hoisted_6),
          _createTextVNode(" " + _toDisplayString(_ctx.getTimestamp(commit.timestamp)) + " ", 1),
          _createElementVNode("p", null, _toDisplayString(commit.message), 1),
          _createElementVNode("button", {
            type: "button",
            onClick: ($event: any) => (_ctx.revertTo(i))
          }, "revert", 8, _hoisted_7)
        ]))
      }), 128))
    ])
  ]))
}